import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyNo',
})
export class EmptyNoPipe implements PipeTransform {
  transform(value: string | number): string | number {
    return value == null || value === '' ? $localize`Нет` : value;
  }
}
